<template>
    <div>
        <h1 class="subtitle">
            Demandes d'accès {{ showPendingRequests ? 'en attente' : 'traitées' }} - {{ user.dgo }}
            <!-- <span id="switch-btn-span">
                <input v-model="showPendingRequests" @change="loadPodRequests()" type="checkbox" class="switch">
            </span> -->
        </h1>
        <!-- <div>
            <span>Afficher en attente d'une réponse : </span>
        </div> -->
        <!-- filters -->
        <!-- <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">GRD</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control select">
                        <select name="GRD" @change="updateSelectedDGO($event)">
                            <option :selected="selectedDGO == dgo" :key="dgo" :value="dgo" v-for="dgo of dgoList">{{ dgo }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">EAN</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input type="text" pattern="\d" inputmode="numeric" maxlength="100" class="input input-medium" v-model="filterEAN" @input="onFilterEANChange()">
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                Demandes traitées <input type="checkbox" v-model="showTreatedRequests" @change="onShowTreatedRequestsChange()">
            </div>
        </div> -->
        <!-- <div class="select field">
            <select disabled name="GRD" @change="updateSelectedDGO($event)">
                <option :selected="selectedDGO == dgo" :key="dgo" :value="dgo" v-for="dgo of dgoList">{{ dgo }}</option>
            </select>
        </div> -->
        <div class="field">
            Demandes traitées <input type="checkbox" v-model="showTreatedRequests" @change="onShowTreatedRequestsChange()">
        </div>
        <div class="input-form field">
            <label>EAN : </label>
            <input type="text" pattern="\d" inputmode="numeric" maxlength="100" class="input input-medium" v-model="filterEAN" @input="onFilterEANChange()">
        </div>

        <div>
            <!-- Table -->
            <div class="table-container">
                <table class="table is-hoverable">
                <thead>
                    <tr>
                        <th>Client</th>
                        <th>GRD</th>
                        <th>EAN</th>
                        <th>Statut</th>
                        <!-- <th>Accès actif</th> -->
                        <th>Date de la demande</th>
                        <th>Détails</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingData"><td class="has-text-centered" colspan="20">Chargement des données ...</td></tr>
                    <template v-else-if="showPendingRequests">
                        <tr v-if="podRequests.length == 0"><td class="has-text-centered" colspan="20">Pas de demandes en attente</td></tr>
                        <tr v-else v-for="podRequest in podRequests" v-bind:key="podRequest.id">
                            <td>{{ podRequest.client ? podRequest.client.email : '-' }}</td>
                            <td>{{ podRequest.dgo }}</td>
                            <td>{{ podRequest.EAN }}</td>
                            <td>En attente</td>
                            <td>{{ formatDateToText(podRequest.requestDate) }}</td>
                            <td><button class="button is-small is-info" @click="setShowPodRequestModal(true, podRequest.id)">Détail</button></td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr v-if="podRequests.length == 0"><td class="has-text-centered" colspan="20">Pas de demandes traitées</td></tr>
                        <tr v-else v-for="podRequest in podRequests" v-bind:key="podRequest.id">
                            <td>{{ podRequest.client ? podRequest.client.email : '-' }}</td>
                            <td>{{ podRequest.dgo }}</td>
                            <td>{{ podRequest.EAN }}</td>
                            <td>{{ getHpReqLastActionText(podRequest) }}</td>
                            <td>{{ formatDateToText(podRequest.requestDate) }}</td>
                            <td><button class="button is-small is-info" @click="setShowPodRequestModal(true, podRequest.id)">Détail</button></td>
                        </tr>
                    </template>
                </tbody>
                </table>
            </div>

            <!-- Pagination -->
            <div class="horizontal-wrapper">
                <div class="field is-grouped">
                <div class="control">
                    Nombre de demandes trouvées : {{nbFiltered}}
                </div>
                </div>
                <div class="field is-grouped">
                <div class="control">
                    <button
                    :disabled="indexPage <= 0 || loadingData"
                    class="button is-small"
                    @click="indexPage--; loadPodRequests()">Précédent</button>
                </div>
                <div class="control"><span class="is-size-7"><strong>Page {{indexPage+1}}</strong></span></div>
                <div class="control">
                    <button
                    :disabled="lastPage || loadingData"
                    class="button is-small"
                    @click="indexPage++; loadPodRequests()">Suivant</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showPodRequestModal" class="modal" :class="{ 'is-active': showPodRequestModal }">
            <div class="modal-background" @click="setShowPodRequestModal(false)"></div>
            <div class="modal-content">
                <div class="box">
                    <div class="title">
                    Demande d'accès :
                    </div>
                    <div>
                        <p style="display: flex; justify-content: flex-end;">Date de la demande : {{ formatDateToText(selectedPodReq.requestDate) }}</p>
                        <div class="hp-req-zone">
                            <div class="label">Infos client</div>
                            <p>Email : {{ selectedPodReq.mail }}</p>
                            <p>Prénom : {{ selectedPodReq.firstName }}</p>
                            <p>Nom : {{ selectedPodReq.lastName }}</p>
                            <!-- <p>Numéro de téléphone : {{ selectedPodReq.phone ? selectedPodReq.phone : "-" }}</p> -->
                        </div>
                        <div class="hp-req-zone">
                            <div class="label hp-req-zone">Point d'accès</div>
                            <p>GRD sélectionné : {{ selectedPodReq.dgo }}</p>
                            <p>EAN : {{ selectedPodReq.EAN }}</p>
                            <p>Numéro de série du compteur : {{ selectedPodReq.meter }}</p>
                            <p>Rue : {{ selectedPodReq.streetName }}</p>
                            <p>Numéro dans la rue : {{ selectedPodReq.streetNumber }}</p>
                            <p>Code postal : {{ selectedPodReq.postalCode }}</p>
                            <p>Localité : {{ selectedPodReq.localityName }}</p>
                            <p>Numéro de boite : {{ selectedPodReq.boxNumber ? selectedPodReq.boxNumber : "-" }}</p>
                        </div>
                        <div v-if="selectedPodReq.comment" class="hp-req-zone">
                            <div class="label hp-req-zone">Commentaire</div>
                            <textarea disabled :value="selectedPodReq.comment" class="textarea has-fixed-size"></textarea>
                        </div>
                    </div>
                    <!-- action history -->
                    <template v-if="selectedPodReq.actionHistory && selectedPodReq.actionHistory.length > 0">
                            <!-- Table for admin action history -->
                            <div id="action-history-table" class="table-container">
                                <h4 class="title is-4">Historique des actions</h4>
                                <table class="table is-hoverable">
                                <thead>
                                    <tr>
                                        <th>Admin</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                        <th>Raison du refus</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr :key="action.date" v-for="action of selectedPodReq.actionHistory">
                                        <td>{{ action.admin }}</td>
                                        <td>{{ formatDateToText(action.date) }}</td>
                                        <td>{{ action.accepted ? 'Demande acceptée' : 'Demande refusée' }}</td>
                                        <td>{{ !action.accepted && action.refuseRequestReason ? action.refuseRequestReason : '-' }}</td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                    </template>
                    <!-- messages and action buttons -->
                    <div id="msg-and-action-btns">
                        <!-- message zone to tell the user what's hapening after executing an action -->
                        <div id="action-result-msg" v-if="changingHpReqStatus || showActionSuccess || showActionFailed">
                            <template v-if="changingHpReqStatus">
                                <strong>Changement du statut de la demande d'accès...</strong>
                            </template>
                            <template v-else-if="showActionSuccess">
                              <div id="action-success-msg">
                                <strong>Action enregistrée</strong>
                              </div>
                            </template>
                            <template v-else-if="showActionFailed">
                              <div id="action-success-msg">
                                <strong>L'action n'a pas pu être enregistrée. Veuillez vérifier la validité des champs encodés dans la demande d'accès. Si l'erreur persiste, contactez un administrateur du portail.</strong>
                              </div>
                              </template>
                        </div>
                        <template v-else-if="showConfirmAccept || showConfirmRefuse || showConfirmCutAccess">
                            <div id="confirm-action-message">
                                <span v-if="showConfirmAccept">Accepter cette demande d'accès ?</span>
                                <div v-else-if="showConfirmRefuse">
                                    <span>Refuser cette demande d'accès ? Cette action est irréversible</span>
                                    <!-- List of reasons to refuse -->
                                     <!-- catégorie -->
                                    <div class="field">
                                        <div class="field" style="margin-right: 10px;">
                                        <label class="label">Raison du refus*</label>
                                        <div class="control">
                                            <div class="select">
                                            <select name="refuseReason" required @change="updateSelectedRefuseReason($event)">
                                                <option :value="null">-</option>
                                                <option :key="refuseReason" :value="refuseReason" v-for="refuseReason of refuseReasons">{{ refuseReason }}</option>
                                            </select>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <textarea v-model="refusalDetails" id="refuse-request-reason" maxlength="100" class="textarea has-fixed-size" placeholder="Information supplémentaire (optionnel)"></textarea>
                                </div>
                                <span v-else>Couper cet accès ? Cette action est irréversible</span>
                            </div>
                            <div id="confirm-action-buttons">
                                <button :disabled="showConfirmRefuse && !refuseReason" class="button is-warning" type="submit" @click="changeStateOfHpRequest(selectedPodReq.id, showConfirmAccept)"><strong>Confirmer</strong></button>
                                <button id="cancel-action-btn" class="button is-info" @click="resetCurrentAction()">Annuler</button>
                            </div>
                        </template>
                        <!-- action buttons -->
                        <div id="action-buttons" v-else-if="!selectedPodReqHadEOC">
                            <button v-if="showPendingRequests" @click="setShowConfirmAction(true)" class="button is-warning"><strong>Accepter la demande</strong></button>
                            <button v-if="showPendingRequests || selectedPodReqIsAccepted" @click="setShowConfirmAction(false)" id="refuse-button" class="button is-danger">
                                <strong>{{ showPendingRequests ? "Refuser la demande" : "Couper l'accès" }}</strong>
                            </button>
                        </div>
                    </div>
                    <!-- close the modal -->
                    <div id="close-button-div">
                        <button @click="setShowPodRequestModal(false)" class="button is-info">Fermer</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import { PodRequestService } from '../../services'
  import moment from 'moment-timezone'

  export default {
    data() {
      return {
        // result infos
        podRequests: [],
        nbFiltered: 0,
        indexPage: 0,
        lastPage: true,
        nbPages: 0,
        nbTotal: 0,
        loadingData: true,
        selectedPodReqID: null,
        showPodRequestModal: false,
        changingHpReqStatus: false,

        // after action status
        showActionSuccess: false,
        showActionFailed: false,
        
        // confirm action
        showConfirmAccept: false,
        showConfirmRefuse: false,
        showConfirmCutAccess: false,
        
        // refuse-request-reason
        refuseRequestReason: "",
        refuseReason: null,
        refusalDetails: "",
        // refuseReasonDropActive: false,
        refuseReasons: [
            "EAN incorrect",
            "Numéro de compteur incorrect",
            "Utilisateur incorrect",
            "Adresse incorrecte",
            "GRD incorrect",
            "Vous ne disposez pas d'un compteur communiquant"
        ],

        // constant
        dgoList: ["REW","AIEG","AIESH"],

        // filters
        showTreatedRequests: false,
        filterEAN: null,
        selectedDGO: null
      }
    },
    computed: {
        ...mapState({ user: state => state.account.user }),
        fullRefusalReason() {
            let fullRefusalReason = ""
            if(this.refuseReason)
                fullRefusalReason = this.refuseReason
            if(this.refusalDetails)
                fullRefusalReason += " - " + this.refusalDetails
            return fullRefusalReason
        },
        selectedPodReq() {
            return this.podRequests.find(podReq => podReq.id == this.selectedPodReqID)
        },
        selectedPodReqHadEOC() {
            if(!this.selectedPodReq)
                return false
            return this.selectedPodReq.endOfContractDetected
        },
        selectedPodReqIsAccepted() {
            if(!this.selectedPodReq || !this.selectedPodReq.actionHistory || !this.selectedPodReq.actionHistory.length > 0)
                return false
            const lastAction = this.selectedPodReq.actionHistory[this.selectedPodReq.actionHistory.length-1]
            return lastAction.accepted
        },
        showPendingRequests() {
            return !this.showTreatedRequests
        }
    },
    methods: {
        updateSelectedRefuseReason(event) {
            this.refuseReason = event.target.value
        },
        updateSelectedDGO(event) {
          this.selectedDGO = event.target.value
          this.indexPage = 0
        //   localStorage.setItem("selectedDGO", this.selectedDGO)
          this.loadPodRequests()
        },
        onFilterEANChange() {
            this.indexPage = 0
            this.loadPodRequests()
        },
        onShowTreatedRequestsChange() {
            this.indexPage = 0
            this.loadPodRequests()
        },
        async loadPodRequests() {
            this.loadingData = true
            this.podRequests =  []
            const result = await PodRequestService.getAdminPodRequests({
                adminID: this.user._id,
                isPendingRequest: this.showPendingRequests,
                pageIndex: this.indexPage,
                nbElPerPage: 10,
                EAN: this.filterEAN ? this.filterEAN : null,
                dgo: this.selectedDGO
            })
            this.loadingData = false
            this.nbFiltered = 0
            if(result && result.podRequests) {
                this.podRequests = result.podRequests
                this.nbFiltered = result.nbFiltered
                this.lastPage = result.lastPage
            }
        },
        formatDateToText(date) {
            return moment(date).format('DD-MM-YYYY')
        },
        getHpReqLastActionText(hpReq) {
            if(hpReq.endOfContractDetected)
              return 'Fin de contrat détectée'
            if(!hpReq.actionHistory || hpReq.actionHistory.length == 0)
                return '-'
            return hpReq.actionHistory[hpReq.actionHistory.length-1].accepted ? 'Accepté' : 'Refusé'
        },
        setShowPodRequestModal(value = null, podRequestID) {
            this.showPodRequestModal = value
            if(value === null)
                this.selectedPodReqID = null
            this.selectedPodReqID = podRequestID
        },
        setShowConfirmAction(accept) {
            this.resetCurrentAction()

            if(accept) 
                return this.showConfirmAccept = true
            if(this.showPendingRequests)
                return this.showConfirmRefuse = true
            return this.showConfirmCutAccess = true  
        },
        resetCurrentAction(){
            this.showConfirmAccept = false
            this.showConfirmRefuse = false
            this.showConfirmCutAccess = false
            this.refuseRequestReason = ""
            this.refuseReason = null
            this.refusalDetails = ""
        },
        async changeStateOfHpRequest(podReqID, accept) {

            this.changingHpReqStatus = true
            const result = await PodRequestService.changeStateOfHpRequest({ accept: accept, adminID: this.user._id, podReqID: podReqID, date: moment().toDate(), refuseRequestReason: this.fullRefusalReason })
          this.changingHpReqStatus = false
            if(result && result.status == "ok") {
                this.showActionSuccess = true
                setTimeout(() => {
                    this.showActionSuccess = false
                    this.setShowPodRequestModal(false)
                    if(this.showPendingRequests)
                        this.removeHpReqFromMemoryList(podReqID)
                    else
                        this.loadPodRequests()
                }, 2000)
            }
            else {
                this.showActionSuccess = false
                this.showActionFailed = true
                setTimeout(() => {
                    this.showActionFailed = false
                }, 15000)
            }
        },
        removeHpReqFromMemoryList(podReqID) {
            const podReqIndex = this.podRequests.findIndex(podReq => podReq.id == podReqID)
            if(podReqIndex < 0)
                return
            this.podRequests.splice(podReqIndex, 1)
        },
    },
    async created() {
        moment.tz.setDefault("Europe/Brussels")
        // let localStorageDGO = localStorage.getItem("selectedDGO")
        // if(localStorageDGO != null) {
        //     this.selectedDGO = localStorageDGO
        // }
        if(!this.user || !this.user.dgo)
            return
        this.selectedDGO = this.user.dgo
        this.loadPodRequests()
    },
    watch: {
        showPodRequestModal() {
            if(!this.showPodRequestModal) {
                this.selectedPodReqID = null
                this.resetCurrentAction()
            }
        }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  #refuse-request-reason {
    margin-top: 15px;
  }
  .hp-req-zone {
    margin-bottom: 8px;
  }
  #confirm-action-message {
    text-align: center;
    font-weight: 700;
    font-size: large;
  }
  #switch-btn-span {
    margin-left: 8px;
    display: inline-block;
    vertical-align: middle;
  }
  #close-button-div {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  }
  #refuse-button, #cancel-action-btn {
    margin-left: 12px;
  }
  #msg-and-action-btns {
    margin-top: 30px;
  }
  #confirm-action-buttons {
    margin-top: 24px;
    justify-content: center;
    display: flex;
  }
  #action-buttons, #action-result-msg {
    justify-content: center;
    display: flex;
  }
//   #action-infos-zone {
//     margin-top: 30px;
//     justify-content: center;
//     display: flex;
//   }
//   #action-success-msg {
//     color: green;
//   }
//   #action-failed-msg {
//     color: red;
//   }
  #action-history-table {
    margin-top: 16px;
  }
  .input-form {
  display: flex;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 10px;
  }
}
.input-small {
  width: 100px !important;
}

.input-medium {
  width: 200px !important;
}

.input-large {
  width: 300px !important;
}
#filters {
    margin-bottom: 2rem;
}
  </style>